import React from 'react'
import { getAuthInstance } from './../helpers/firebase'
import { RouteReplace } from './../helpers/routing'
import moment from 'moment'

const isLogged = () => {
  if (!global.sessionStorage) {
    return false
  }

  return sessionStorage.getItem('logged') === '1' && sessionStorage.getItem('profile') !== null
}

const isSubscriptionActive = () => {
  const stringifiedProfile = sessionStorage.getItem('profile')

  if (!stringifiedProfile) return false

  let profile

  try {
    profile = JSON.parse(stringifiedProfile)
  }
  catch (e) {
    return false
  }

  const { subscription } = profile || {}
  const { active, expirationDate } = subscription || {}
  const today = moment().format('YYYY-MM-DD')

  return active && today < expirationDate
}

const withAuthentication = (Component) =>
  class WithAuthentication extends React.Component {

    static async getInitialProps(data) {
      const { pathname = '', url = '', req = {} } = data
      const { locale = process.env.DEFAULT_LANG, nextRoute = {} } = req

      const componentData = await Component.getInitialProps(data)
      const actualRoute = nextRoute.name || pathname.split('/').pop() || url.split('/').pop() || ''

      return { ...componentData, locale, actualRoute }
    }

    constructor(props) {
      super(props)

      this.state = {
        authUser: null,
        logged: isLogged()
      }
    }

    componentWillUnmount() {
      this.willUnmount = true
    }

    componentDidMount() {
      const { actualRoute, locale } = this.props
      const { logged } = this.state

      if (logged) {
        if (!isSubscriptionActive() && actualRoute !== 'inactive-subscription') {
          RouteReplace('inactive-subscription', locale)
          return
        }
        else if (actualRoute === 'login' || isSubscriptionActive() && actualRoute === 'inactive-subscription') {
          RouteReplace('dashboard', locale)
          return
        }
      }
      else {
        if (actualRoute !== 'login') {
          RouteReplace('login', locale)
          return
        }
      }

      getAuthInstance().onAuthStateChanged(authUser => {
        if (!authUser || this.willUnmount) return

        this.setState({ authUser })
      })
    }

    render() {
      const { actualRoute } = this.props
      const { authUser, logged } = this.state

      if (authUser || (!logged && actualRoute === 'login')) {
        return <Component {...this.props} authUser={authUser} />
      }

      return null
    }
  }

export default withAuthentication


// WEBPACK FOOTER //
// src/HOC/withAuthentication.js